<template>
    <div class="models page">
        <div class="wrapper">
            <div class="loader" v-if="!application">
                <img src="/assets/images/talents/loader.gif">
            </div>
            <proposal-menu mode="start" v-if="application"></proposal-menu>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import ProposalMenu from "./ProposalMenu";

    export default {
        components: {
            ProposalMenu,
        },
        props: ['applicationId'],
        data: function () {
            return {}
        },
        created() {
        },
        mounted() {
            this.fetchApplication(this.applicationId);
        },
        computed: {
            ...mapState(['application'])
        },
        watch: {},
        methods: {

        },
    }
</script>
